// Limited to these flags for now. We will include all d2c flags later.
const ALLOWED_FLAG_KEYS = ['d2CFeatUapply', 'd2CFeatAffiliatesUapply', 'd2CFeatHandoffPage'] as const;

export function getFormattedLDFlags(flags?: Record<string, unknown> | null): string {
  const source = flags ?? {};
  return ALLOWED_FLAG_KEYS.filter((key) => source[key] !== undefined)
    .map((key) => `${key}-${source[key]}`)
    .join(' | ');
}
